import WitnessCard from './WitnessCard';

export default WitnessCard;
